import { GridSkeleton } from "@/components/Skeletons";

export default function DocumentsSkeleton() {
  return <GridSkeleton columns={9} rows={12} />;
}
